'use client';
import IconArrowDown from '@/assets/icons/order/icon-arrow-down.svg';
import React, { useRef } from 'react';
import styles from './custom-accordion.module.scss';
import useHasMounted from '@/hooks/useHasMounted';
import { useTranslations } from 'next-intl';
//  accordionitem component

const CustomAccordion: React.FC<{
  title: string;
  price: string;
  children: any;
  isOpen: boolean;
  onClick: () => void;
}> = ({ title, children, price, isOpen, onClick }) => {
  const contentHeight = useRef<any>();

  const hasMounted = useHasMounted();
  const t = useTranslations('Components.product-accordion');
  return (
    <div className={styles.accordionWrapper}>
      {hasMounted && (
        <button className={`${styles.accordionContainer} `} onClick={onClick}>
          <div className={styles.iconTitle}>
            <p className={styles.title}>{title}</p>
            <IconArrowDown
              className={`${styles.arrow} ${isOpen ? styles.active : ''}`}
            />
          </div>
          <h4 className={styles.price}>
            {price} {t('price')}
          </h4>
        </button>
      )}

      <div
        ref={contentHeight}
        className={styles.answerContainer}
        style={
          isOpen
            ? { height: contentHeight?.current?.scrollHeight }
            : { height: '0px' }
        }
      >
        {children}
      </div>
    </div>
  );
};

export default CustomAccordion;
